<div id="check-{{name}}" class="checkbox" (click)="toggle()">
  <div
    class="check"
    [style.backgroundImage]="check ? checkboxBgPath : ''"
    [class.checked]="check"
  ></div>
  <span class="B1-LatoRegular-C6">{{ message }}</span>
</div>
